import { useState } from "react";
import "./Home.css";
import heroImg from "../background-2.jpg";
import aboutImg from "../image.png";
import smartImg from "../qeeper-background.jpeg";
import secureImg from "../qeeper-background-2.jpeg";
import flexibleImg from "../panel.jpg";
import apiImg from "../sk-31.jpg";
import securityImg from "../sk-22.jpg";
import phoneImg from "../phone.png";
import { FaLinkedinIn } from "react-icons/fa";
import { NavLink } from "react-router-dom";

const HomePage = () => (
  <div className="home-page">
    <HeroSection />
    <AboutSection />
    <SmartManagementSection />
    <SecureAccessSection />
    <FlexibleSection />
    <ApiSection />
    <SecuritySection />
    <MyLockerSection />
    <ContactFormSection />
  </div>
);

/* Hero */
const HeroSection = () => (
  <section className="hero">
    <div className="hero__image-wrapper">
      <img src={heroImg} alt="Smart locker solution" className="hero__image" />
      <div className="hero__overlay">
        <h1 className="hero__title">
          Discover the ultimate smart solution for locker access control and
          management.
        </h1>
        <NavLink to="/about/services" className="hero__cta">
          Learn more about our services
        </NavLink>
        <a
          href="https://www.linkedin.com/company/qeeper-nordic"
          target="_blank"
          rel="noopener noreferrer"
          className="hero__social"
          aria-label="LinkedIn"
        >
          <FaLinkedinIn />
        </a>
      </div>
    </div>
  </section>
);

/* About */
const AboutSection = () => (
  <section className="content-section">
    <div className="content-section__inner">
      <div className="content-section__image">
        <img src={aboutImg} alt="About Qeeper" />
      </div>
      <div className="content-section__text">
        <h2>About Qeeper</h2>
        <p>
          It is the ultimate smart solution for locker access control and
          management, tailored to meet the dynamic needs of modern
          organizations. Whether it's for securely storing personal belongings,
          dispensing products, managing rentals, or facilitating internal mail
          and parcel distribution – Qeeper provides an intuitive and flexible
          system that addresses all your challenges.
        </p>
      </div>
    </div>
  </section>
);

/* Smart Management */
const SmartManagementSection = () => (
  <section className="split-section">
    <div className="split-section__grey">
      <div className="split-section__text">
        <h2>Smart Management, Anytime, Anywhere</h2>
        <p>
          With Qeeper, you can easily manage your lockers through a
          user-friendly online interface. Our innovative software gives you
          complete control, accessible from any device, including your
          smartphone. Monitor and manage lockers remotely, without the need for
          on-site staff intervention.
        </p>
      </div>
    </div>
    <div className="split-section__image">
      <img src={smartImg} alt="Smart management" />
    </div>
  </section>
);

/* Secure Access */
const SecureAccessSection = () => (
  <section className="content-section">
    <div className="content-section__inner">
      <div className="content-section__image">
        <img src={secureImg} alt="Secure access" />
      </div>
      <div className="content-section__text">
        <h2>Simple and Secure Access</h2>
        <p>
          Your users will enjoy maximum convenience with access via RFID cards,
          PIN codes, QR codes, or our handy smartphone app. No more keys, no
          more hassle – locker access has never been this easy.
        </p>
      </div>
    </div>
  </section>
);

/* Flexible */
const FlexibleSection = () => (
  <section className="split-section">
    <div className="split-section__grey">
      <div className="split-section__text">
        <h2>Flexible and Customizable</h2>
        <p>
          Whether you need lockers for your office, school, event, or sports
          center, Qeeper seamlessly adapts to your needs. Choose between
          permanent (static) or temporary (dynamic) locker assignments, ensuring
          you use fewer lockers, save space, and increase efficiency.
        </p>
      </div>
    </div>
    <div className="split-section__image">
      <img src={flexibleImg} alt="Flexible and customizable" />
    </div>
  </section>
);

/* API */
const ApiSection = () => (
  <section className="content-section">
    <div className="content-section__inner">
      <div className="content-section__image">
        <img src={apiImg} alt="API integration" />
      </div>
      <div className="content-section__text">
        <h2>Seamless Integration with API</h2>
        <p>
          With Qeeper's extensive API integration, the system fits perfectly
          with your existing IT and facility management systems. This ensures an
          unparalleled experience for both administrators and users, making your
          lockers part of a fully integrated ecosystem.
        </p>
      </div>
    </div>
  </section>
);

/* Security */
const SecuritySection = () => (
  <section className="split-section">
    <div className="split-section__grey">
      <div className="split-section__text">
        <h2>Security First</h2>
        <p>
          Security is our top priority. Qeeper offers full end-to-end
          encryption, ensuring the protection of your data and locker access.
          Real-time monitoring and alerts keep you informed of any unusual
          activity, giving you peace of mind that your assets and belongings are
          always safe.
        </p>
      </div>
    </div>
    <div className="split-section__image">
      <img src={securityImg} alt="Security first" />
    </div>
  </section>
);

/* MyLocker App */
const MyLockerSection = () => (
  <section className="content-section content-section--mylocker">
    <div className="content-section__inner content-section__inner--centered">
      <div className="content-section__image content-section__image--phone">
        <img src={phoneImg} alt="MyLocker app" />
      </div>
      <div className="content-section__text">
        <h2 className="mylocker-title">
          MyLocker app,
          <br />
          secure and convenient!
        </h2>
        <p>
          Experience the ultimate convenience in locker control! With just your
          smartphone, you unlock and manage your lockers anytime, anywhere. The
          MyLocker app even notifies you instantly when a parcel arrives,
          keeping you connected and in control. Simplify your life with
          effortless access and real-time updates—unlock the future with
          MyLocker!
        </p>
      </div>
    </div>
  </section>
);

/* Contact Form */
const ContactFormSection = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    topic: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(formData.topic || "Contact Form");
    const body = encodeURIComponent(
      `Name: ${formData.firstName} ${formData.lastName}\nEmail: ${formData.email}\nPhone: ${formData.phone}\n\n${formData.message}`,
    );
    window.location.href = `mailto:sales@qeeper-nordic.com?subject=${subject}&body=${body}`;
  };

  return (
    <section className="contact-form-section">
      <div className="contact-form-wrapper">
        <h2>Get in touch with us</h2>
        <p className="contact-form-desc">
          Looking for a smart locker solution for your organization? Leave your
          details and message here, and our team will get in touch with you
          shortly to discuss the possibilities. Together, we'll find the perfect
          solution for your organization!
        </p>
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="contact-form__row">
            <div className="contact-form__field">
              <label htmlFor="cf-firstName">First Name</label>
              <input
                id="cf-firstName"
                name="firstName"
                type="text"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="contact-form__field">
              <label htmlFor="cf-lastName">Last Name</label>
              <input
                id="cf-lastName"
                name="lastName"
                type="text"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="contact-form__row">
            <div className="contact-form__field">
              <label htmlFor="cf-email">Email</label>
              <input
                id="cf-email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="contact-form__field">
              <label htmlFor="cf-phone">Phone</label>
              <input
                id="cf-phone"
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="contact-form__field contact-form__field--full">
            <label htmlFor="cf-topic">Topic</label>
            <select
              id="cf-topic"
              name="topic"
              value={formData.topic}
              onChange={handleChange}
              required
            >
              <option value="">Select a topic</option>
              <option value="Storage Solutions">Storage Solutions</option>
              <option value="Dispensing Solutions">Dispensing Solutions</option>
              <option value="Rental Solutions">Rental Solutions</option>
              <option value="General Inquiry">General Inquiry</option>
              <option value="Partnership">Partnership</option>
            </select>
          </div>
          <div className="contact-form__field contact-form__field--full">
            <label htmlFor="cf-message">Message</label>
            <textarea
              id="cf-message"
              name="message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit" className="contact-form__submit">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default HomePage;
